import { jsx as _jsx } from "react/jsx-runtime";
import { chakra } from '@chakra-ui/react';
import { usePrefersReducedMotion } from '../../lib/use-prefers-reduced-motion';
const dotSize = { sm: '1.5', md: '2' };
/**
 * The lilac dot of "something is happening". It breathes, unless the viewer
 * asked for less motion, in which case it simply stays lit.
 */
export function PulseDot({ size = 'sm' }) {
    const still = usePrefersReducedMotion();
    return (_jsx(chakra.span, { "aria-hidden": "true", "data-pulse": still ? 'still' : 'animated', display: "inline-block", flexShrink: 0, boxSize: dotSize[size], mx: "1", borderRadius: "full", bg: "agent.accent", animation: still ? undefined : 'agent-pulse-dot 1s ease-in-out infinite', _motionReduce: { animation: 'none' } }));
}
